import './DateInput.css';

import React, { Component } from 'react';

import CustomInput from '../CustomInput/CustomInput';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import PropTypes from 'prop-types';
import config from '../../config/config';
import moment from 'moment';

const dateFormat = config.getDateFormat();
const dateToServer = config.getDateToServer();

class DateInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: '',
            dateState: '',
            shrink: false,
            errorMessage: '',  // Agrega un estado para el mensaje de error
        }
    }

    componentDidMount() {
        if (this.props.value && this.props.value !== '') {
            this.setState({ shrink: true });
        }

        if (this.props.invalid) {
            this.setState({ dateState: 'error' });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.props.value !== '') {
            this.setState({ shrink: true });
        }

        if (this.props.invalid && prevProps.invalid !== this.props.invalid) {
            this.setState({ dateState: 'error' });
        }
    }

    change(value) {
        if (this.props.disabled) {
            return;
        }

        const momentValue = moment(value);
        const minValue = moment(this.props.min);
        const maxValue = moment(this.props.max);

        if (value.length > 0) {
            this.setState({ shrink: true });
        }

        if (this.props.typeValidation  && (this.props.validation && momentValue.isValid())) {
            if (momentValue.isBefore(moment().startOf('day'))) {
                console.log('La fecha ingresada es anterior a la de hoy.');
                this.setState({
                    dateState: 'error',
                    errorMessage: 'La fecha no puede ser anterior a la actual.',
                });
                this.props.onChangeValue('');
            } else if (momentValue.isBefore(minValue)) {
                console.log('La fecha ingresada es anterior al mínimo permitido.');
                this.setState({
                    dateState: 'error',
                    errorMessage: `La fecha no puede ser anterior a ${this.props.min}.`,
                });
                this.props.onChangeValue('');
            } else if (momentValue.isAfter(maxValue)) {
                console.log('La fecha ingresada es posterior al máximo permitido.');
                this.setState({
                    dateState: 'error',
                    errorMessage: `La fecha no puede ser posterior a ${this.props.max}.`,
                });
                this.props.onChangeValue('');
            }
            else if (value?.format) {
    
                this.props.onChangeValue(`${value.format(dateToServer)} 00:00:00.000`);
                this.setState({
                    dateState: 'success',
                    shrink: true,
                    errorMessage: '',  
                });
            }
        }else if (!this.props.typeValidation && (this.props.validation && momentValue.isValid() && momentValue.isBefore(moment().startOf('day')))) {

            this.setState({
                dateState: 'error',
                errorMessage: 'La fecha no puede ser anterior a la actual.',  
            });
            this.props.onChangeValue(''); 
        } 
         else if (value?.format) {

            this.props.onChangeValue(`${value.format(dateToServer)} 00:00:00.000`);
            this.setState({
                dateState: 'success',
                shrink: true,
                errorMessage: '',  
            });
        } else {
            this.props.onChangeValue('');
        }
    }

    handleBlur(value) {
        const momentValue = moment(value);
        if (momentValue.isValid()) {
            this.setState({
                dateState: 'success',
                shrink: true,
                errorMessage: '',  
            });
        } else if (value == null || value.length === 0) {
            this.setState({ shrink: false });
        }
    }

    render() {
        const {
            disabled, error, errorText, fullWidth, max, maxDate, min, minDate, sm, value, text, id, validation, typeValidation
        } = this.props;

        const { dateState, shrink, errorMessage } = this.state;  

        return (
            <GridContainer className="date-input">
                <GridItem xs={12} sm={sm || 7}>
                    <CustomInput
                        id={id}
                        dateShrink={shrink}
                        labelText={text}
                        helpText={errorText || errorMessage}  
                        error={dateState === "error" || error}
                        formControlProps={{
                            fullWidth,
                        }}
                        minDate={minDate}
                        maxDate={maxDate}
                        closeOnSelect={true}
                        disabled={disabled}
                        dateValue={value ? moment.utc(value).format(dateFormat) : value}
                        type="date"
                        min={min}
                        max={max}
                        time={false}
                        onChange={event => this.change(event)}
                        onBlur={event => this.handleBlur(event)}
                        inputProps={{
                            disabled,
                        }}
                        className={disabled ? 'disabled' : ''}
                    />
                    
                </GridItem>
            </GridContainer>
        )
    }
}

DateInput.defaultProps = {
    fullWidth: true,
    id: '',
}

DateInput.propTypes = {
    text: PropTypes.string,
    value: PropTypes.any,
    onChangeValue: PropTypes.func,
    invalid: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    minDate: PropTypes.bool,
    maxDate: PropTypes.bool,
    fullWidth: PropTypes.bool,
    validation:PropTypes.bool,
    min: PropTypes.string,
    max: PropTypes.string,
    sm: PropTypes.number,
    id: PropTypes.string,
}

export default DateInput;
